import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, ViewChild, ElementRef, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-new-project-hero',
  templateUrl: './new-project-hero.component.html',
  styleUrls: ['./new-project-hero.component.css'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewProjectHeroComponent implements OnInit, OnChanges {
  @Input() formGroup!: FormGroup | null;
  @Input() mainImageUrl: string | null = null;
  @Output() imageSelected = new EventEmitter<{event: any, id: string}>();
  @Output() imageRemoved = new EventEmitter<string>();
  @ViewChild('fileInput') fileInput!: ElementRef;
  
  hasImage: boolean = false;

  get estadoControl(): FormControl | null {
    return this.formGroup?.get('status') as FormControl || null;
  }

  get rentabilidadAnualControl(): FormControl | null {
    return this.formGroup?.get('annualProfitability') as FormControl || null;
  }

  get duracionRealControl(): FormControl | null {
    return this.formGroup?.get('estimatedDeliveryPeriod') as FormControl || null;
  }


  constructor() {}

  ngOnInit(): void {
    // Verificar si hay imagen principal
    console.log('🔍 new-project-hero ngOnInit - mainImageUrl:', this.mainImageUrl);
    this.hasImage = !!this.mainImageUrl;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['mainImageUrl']) {
      console.log('🔍 new-project-hero ngOnChanges - mainImageUrl:', this.mainImageUrl);
      this.hasImage = !!this.mainImageUrl;
    }
  }

  onImageClick() {
    this.fileInput.nativeElement.click();
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      // Crear una URL local para previsualización
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.mainImageUrl = e.target.result;
        this.hasImage = true;
        // Emitir evento al componente padre con el archivo para almacenamiento local
        this.imageSelected.emit({event: event, id: 'fotoPrincipal'});
      };
      reader.readAsDataURL(file);
    }
  }

  uploadNewImage(event: Event): void {
    event.stopPropagation();
    console.log('📤 Subiendo nueva imagen...');
    this.fileInput.nativeElement.click();
  }

  changeExistingImage(event: Event): void {
    event.stopPropagation();
    console.log('🔄 Cambiando imagen existente...');
    this.fileInput.nativeElement.click();
  }

  removeImage(event: Event): void {
    event.stopPropagation();
    console.log('🗑️ Eliminando imagen...');
    this.mainImageUrl = null;
    this.hasImage = false;
    this.imageRemoved.emit('fotoPrincipal');
  }

}
